module.exports = __webpack_public_path__ + "img/school-news-white.57a502ae.svg";